function parseAppVersion(version: string): [major: number, minor: number, patch: number] {
  const numericParts = version.match(/\d+/g)?.map(Number) ?? [0, 0, 0]

  return [numericParts[0] ?? 0, numericParts[1] ?? 0, numericParts[2] ?? 0]
}

/** Prompt only when the major or minor segment changes, e.g. 1.65.32 -> 1.66.1 */
export function requiresUpdatePrompt(currentVersion: string, nextVersion: string): boolean {
  const [currentMajor, currentMinor] = parseAppVersion(currentVersion)
  const [nextMajor, nextMinor] = parseAppVersion(nextVersion)

  return nextMajor !== currentMajor || nextMinor !== currentMinor
}

export function isPatchUpdate(currentVersion: string, nextVersion: string): boolean {
  return !requiresUpdatePrompt(currentVersion, nextVersion)
}
